import React, { useEffect, useState } from 'react'
import { Alert, Button, Group, Text } from '@mantine/core'
import { ClockIcon, ExclamationTriangleIcon } from '@radix-ui/react-icons'

import { useAvailabilityOwner } from './useAvailabilityOwner'
import { WeeklyAvailabilityModal } from './WeeklyAvailabilityModal'
import { getWeekStart } from './weekUtils'

import { useCalendarParams } from '@/queries/useCalendarParams'
import { useWeeklyAvailabilityQuery } from '@/queries/weeklyAvailability'

export const WeeklyAvailabilityBanner: React.FC = () => {
  const availabilityOwner = useAvailabilityOwner()
  const calendarParams = useCalendarParams()
  const [isOpen, setIsOpen] = useState(false)

  const weekStart = calendarParams ? getWeekStart(calendarParams.date) : null

  const { data: response } = useWeeklyAvailabilityQuery(
    availabilityOwner?.owner ?? null,
    weekStart ?? new Date(),
    { enabled: !!weekStart && calendarParams?.view === 'week' },
  )

  const data = response?.data
  const shouldShowBanner =
    !!availabilityOwner &&
    !!weekStart &&
    calendarParams?.view === 'week' &&
    !!data &&
    !data.is_read_only &&
    (data.ranges ?? []).length === 0 &&
    !data.last_updated_at

  useEffect(() => {
    if (!shouldShowBanner) {
      setIsOpen(false)
    }
  }, [shouldShowBanner])

  if (!shouldShowBanner) {
    return null
  }

  return (
    <>
      <Alert
        color="yellow"
        icon={<ExclamationTriangleIcon />}
        className="mx-4 mt-4 mb-6"
        styles={{ message: { width: '100%' } }}
      >
        <Group position="apart" noWrap className="w-full">
          <Text size="sm">No availability set for this week</Text>
          <Button
            size="xs"
            variant="white"
            leftIcon={<ClockIcon />}
            onClick={() => setIsOpen(true)}
          >
            Set availability
          </Button>
        </Group>
      </Alert>
      {isOpen && (
        <WeeklyAvailabilityModal
          owner={availabilityOwner.owner}
          defaultTimezone={availabilityOwner.defaultTimezone}
          initialWeekStart={weekStart}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  )
}
